const currencyFormat: Intl.NumberFormatOptions = {
    currency: 'EUR',
    style: 'currency',
    minimumIntegerDigits: 1,
    maximumFractionDigits: 2,
};

export const LocaleSettings = {
    DateFormat: 'D-M-YYYY',
    Locale: 'nl-NL',
};
const currencyFormatter = new Intl.NumberFormat(LocaleSettings.Locale, currencyFormat);
export function formatCurrency(value: number): string {
    if (!value)
        return '';

    return currencyFormatter.format(value);
}

export function parseNumber(value: string) {
    if (!value)
        return null;

    // Ignores any non number prefix (e.g. whitespace or currency symbol)
    // Any digits + . until the first ,  for the whole 
    // 0-N digits after the , for the fraction
    const result = /^[^-\d]*(-?)(\s*[\d.]+)(,(\d{0,}))?\s*$/ig.exec(value)
    if (!result)
        return NaN;

    const negative = result[1] === '-' ? -1 : 1;
    const whole = parseInt(result[2].replace(/[^\-\d]/ig, ''), 10);
    let fraction = parseInt(result[4], 10);;
    if (isNaN(fraction))
        fraction = 0;
    else
        fraction = fraction / Math.pow(10, result[4].length);

    return negative * ((isNaN(whole) ? 0 : whole) + fraction);
}